import { memo, VFC, useState, useEffect } from 'react';
import {
  Center,Text,Box
} from '@chakra-ui/react';
import { useLoginUser } from '../../hooks/providers/useLoginUserProvider';

type Props = {
  page: string;
};

export const TenantList: VFC<Props>  = memo((props) => {
  const NECAUTH_URL = process.env.REACT_APP_NECAUTH_URL;
  if (NECAUTH_URL == null) {
    throw Error('REACT_APP_NECAUTH_URL not defined.');
  }
  const { page } = props;
  const { loginUser } = useLoginUser();
  const [ authURL ] = useState(NECAUTH_URL);
  const appType = process.env.REACT_APP_APP_TYPE;
  const [ noExecFlag, setNoExecFlag ] = useState(false);
  
  useEffect(() => {
    // 管理側では、NEC外からはテナント管理アクセスなし
    if( appType === 'ADMIN' && !loginUser.nec_network ){
      setNoExecFlag(true);
      return;
    }
    const iframe = document.querySelector("iframe");
    
    let cognitoId = '';
    if( process.env.REACT_APP_AUTH_INFO ){
      cognitoId = process.env.REACT_APP_AUTH_INFO.split(',')[2];
    }
    
    window.addEventListener('message', function (e) {
      switch (e.data.action) {
        case 'SyncMessage': {
          loginUser.envType && console.log('メッセージ',e.data.message);
          const cogniteInfo = 'CognitoIdentityServiceProvider.' + cognitoId;
          const cogniteInfoAndName = cogniteInfo + '.' + loginUser.username;
          const clockDriftKey = cogniteInfoAndName+'.clockDrift';
          const userDataKey = cogniteInfoAndName+'.userData';
          const accessTokenKey = cogniteInfoAndName+'.accessToken';
          const idTokenKey = cogniteInfoAndName+'.idToken';
          const refreshTokenKey = cogniteInfoAndName+'.refreshToken';
          const LastAuthUserKey = cogniteInfo+'.LastAuthUser';
          const userNameKey = 'amplify-signin-with-hostedUI';
          
          const obj = [
            {
              key : clockDriftKey,
              data: localStorage.getItem(clockDriftKey)
            },
            {
              key : userDataKey,
              data: localStorage.getItem(userDataKey)
            },
            {
              key : accessTokenKey,
              data: localStorage.getItem(accessTokenKey)
            },
            {
              key : idTokenKey,
              data: localStorage.getItem(idTokenKey)
            },
            {
              key : refreshTokenKey,
              data: localStorage.getItem(refreshTokenKey)
            },
            {
              key : LastAuthUserKey,
              data: localStorage.getItem(LastAuthUserKey)
            },
            {
              key : userNameKey,
              data: localStorage.getItem(userNameKey)
            },
          ];
          if( iframe && iframe.contentWindow ){
            iframe.contentWindow.postMessage({
              action: 'authData',
              message: obj
            }, authURL, );
            loginUser.envType === 'DEV' && console.log('親からの送信');
          }
          
          break;
        }
      }
    });
  }, [loginUser.username,authURL]);
  
  return (
    <>
    {noExecFlag ? (
      <Box bgColor="white" paddingLeft={4} marginTop="10px" marginBottom='7px' borderRadius="10px">
        <Center h="20vh">
          <Text>社外からアクセスできません。</Text>
        </Center>
      </Box>
    ) : (
      <iframe id="tenantList"
        title="tenantList"
        width="100%"
        height="800px"
        src={authURL+`login.html?url=/${page}&serviceId=necnotice`}>
      </iframe>
    )}
    </>
  );
});